export const hasAtLeastOneDigit = (value: string) => {
  return /\d/.test(value);
};
